import apiFetch from '../apiFetch'

export default function (idProducto, token) {
  return apiFetch({endPoint: `Producto/deleteProducto?idProducto=` + idProducto, method: 'GET', body: null, token: token})
}